export class MyprofileRequestModel{
    "userId":Number;
    "siteId":Number;
}